import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import ProgressLoadingBar from '../ProgressLoadingBar';
import ProgressLoad from '../new-components';

/**
 *  A React component that renders a loading indicator.
 * If progress is not provided, it will render a fake progress indicator based on the speed level.
 * Optionally a textBlock can be provided to display a message.
 */
function LoadingIndicatorProgress({ className, textBlock, progress, speed = "medium" }) {
    const [fakeProgress, setFakeProgress] = useState(0);

    const speedConfig = {
        slow: { increment: 0.1, interval: 100 },
        'slow-medium': { increment: 0.3, interval: 75 },
        medium: { increment: 0.5, interval: 50 },
        'medium-fast': { increment: 0.9, interval: 20 },
        fast: { increment: 1, interval: 10 },
    };

    useEffect(() => {
        let intervalId;
        if (progress === undefined) {

            const { increment, interval } = speedConfig[speed] || speedConfig.medium;

            intervalId = setInterval(() => {
                setFakeProgress((prev) => {
                    if (prev >= 95) return 95; // Stop at 95% to simulate near-completion
                    return prev + increment;
                });
            }, interval);
        }

        return () => clearInterval(intervalId);
    }, [progress, speed]);

    return (
        <div
            className={classNames(
                'absolute top-0 left-0 z-50 flex flex-col items-center justify-center space-y-5',
                className
            )}
        >
            <div className="w-56">
                {progress !== undefined ? (
                    <ProgressLoadingBar progress={progress} />
                ) : (
                    <ProgressLoad progress={fakeProgress} />
                )}
            </div>
            {textBlock}
        </div>
    );
}

export default LoadingIndicatorProgress;
